import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "fill",
      d: "M12.0771 0.696579C12.2876 0.478652 12.5393 0.304827 12.8177 0.185245C13.0961 0.0656624 13.3955 0.00271882 13.6985 8.61499e-05C14.0014 -0.00254652 14.3019 0.0551847 14.5823 0.169911C14.8627 0.284637 15.1175 0.454061 15.3317 0.668297C15.5459 0.882533 15.7154 1.13729 15.8301 1.4177C15.9448 1.69812 16.0025 1.99857 15.9999 2.30154C15.9973 2.6045 15.9343 2.90391 15.8148 3.18228C15.6952 3.46066 15.5213 3.71244 15.3034 3.92292L14.3987 4.82761L11.1724 1.60128L12.0771 0.696579ZM9.55922 3.21445L0 12.7737V16H3.22634L12.7867 6.44078L9.55808 3.21445H9.55922Z",
      fill: "#212225"
    }, null, -1)
  ])))
}
export default { render: render }